module.exports = __webpack_public_path__ + "media/images/loading1-e25d5ae470a47ea620508d184429c781.gif";